var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy-container",rawName:"v-lazy-container",value:({ selector: 'img' }),expression:"{ selector: 'img' }"}],class:`${_vm.roundedPlaceholderClass}`},[_c('img',{class:_vm.imageClass,attrs:{"data-src":_vm.resolvedImageUrl,"data-loading":_vm.resolvedPlaceholderUrl,"width":_vm.width,"height":_vm.height,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }